import { useEffect, useMemo } from 'react';
import { useAudio } from 'src/features/audio';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { useSocketIO } from 'src/socket';
import { VoiceChannelParticipantAudioTracks } from '../../features/VoiceChannelParticipants/VoiceChannelParticipantAudioTracks';
import { useVoiceChannelContext } from './VoiceChannelContext';

export const VoiceChannelEventsHandler = () => {
  const audio = useAudio();
  const { io } = useSocketIO();

  const {
    room,
    audioPlay,
    activeVoiceChannel,
    connectionStatus,
    setConnectionStatus,
    myMeetId,
    remoteParticipants,
  } = useLivekitRTCState();

  const { connectVoiceChannel } = useVoiceChannelContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: check this later\
  useEffect(() => {
    if (!myMeetId) return;
    switch (connectionStatus) {
      case 'connected':
        if (!activeVoiceChannel?.channel?._id) return;
        io.emit(`/voice-channel/member/update`, {
          channelId: activeVoiceChannel.channel._id,
          member: {
            meetId: myMeetId,
          },
        });
        break;
      case 'reconnecting':
        connectVoiceChannel({ channel: activeVoiceChannel.channel });
        break;
      case 'reconnected':
        // TODO send socket
        setConnectionStatus('connected');
        break;
      case 'disconnected':
        // console.log('===> HANDLER =>> disconnected ')
        break;
      default:
        break;
    }
  }, [connectionStatus, myMeetId]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: check this later
  useEffect(() => {
    if (!audioPlay) return;
    audio.play(audioPlay, { skipLastPlayed: true });
  }, [audioPlay]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const participants = useMemo(() => {
    return Array.from(room?.remoteParticipants?.values() || []);
  }, [room?.remoteParticipants, remoteParticipants]);

  if (!participants.length) return null;

  return (
    <>
      {participants.map((participant) => (
        <VoiceChannelParticipantAudioTracks
          key={participant.sid}
          participant={participant}
        />
      ))}
    </>
  );
};
